import * as React from 'react'
import transpileTypeScript from '../shared/transpileTypeScript'
import type { ReactAssetRuntime, RenderData } from '../assetTypes'

export type FeatureComponentProps = {
  trellis: ReactAssetRuntime
  renderData?: RenderData
  content: string
}

type FeatureModuleExports = {
  default?: unknown
}

const IMPORT_STATEMENT_PATTERN = /^\s*import[\s{*]/m
const REQUIRE_CALL_PATTERN = /\brequire\s*\(/

const isSupportedReactComponent = (value: unknown) =>
  typeof value === 'function' || (typeof value === 'object' && value !== null && '$$typeof' in value)

const compileFeatureComponent = (content: string) => {
  const source = String(content || '')
  if (!source.trim()) throw new Error('Feature payload is empty.')
  if (IMPORT_STATEMENT_PATTERN.test(source)) {
    throw new Error('Feature payload must not import modules. The runtime already provides React.')
  }
  if (REQUIRE_CALL_PATTERN.test(source)) {
    throw new Error('Feature payload must not call require(...).')
  }

  const compiled = transpileTypeScript(source, {
    module: 'commonjs',
    jsx: true,
  })

  const module = { exports: {} as FeatureModuleExports | React.ComponentType<FeatureComponentProps> }
  const execute = new Function('React', 'module', 'exports', compiled)
  execute(React, module, module.exports)

  const exported = (module.exports as FeatureModuleExports).default ?? module.exports
  if (!isSupportedReactComponent(exported)) {
    throw new Error('Feature payload must export a default React component.')
  }

  return exported as React.ComponentType<FeatureComponentProps>
}

export default compileFeatureComponent
